import React from 'react';
import { CheckPicker } from 'rsuite';
import { ADMIN_PERMISSION, GRANTABLE_PERMISSIONS, PERMISSION_OPTIONS } from '../../config/permissions';

/**
 * Multi-select of permission grants. Administrator implies the rest, so while
 * it is on they show ticked and locked; unticking it clears the lot, since those
 * ticks were never grants of their own. Works as a Form.Control accepter.
 */
export default function PermissionPicker({ value, onChange, ...props }) {
  const selected = Array.isArray(value) ? value : [];
  const isAdmin = selected.includes(ADMIN_PERMISSION);

  const handleChange = (next, event) => {
    const list = Array.isArray(next) ? next : [];
    if (list.includes(ADMIN_PERMISSION) && !isAdmin) return onChange?.([ADMIN_PERMISSION], event);
    if (isAdmin) return onChange?.([], event);
    return onChange?.(list, event);
  };

  return (
    <CheckPicker
      data={PERMISSION_OPTIONS}
      value={isAdmin ? [ADMIN_PERMISSION, ...GRANTABLE_PERMISSIONS] : selected}
      onChange={handleChange}
      disabledItemValues={isAdmin ? GRANTABLE_PERMISSIONS : []}
      searchable={false}
      cleanable
      block
      placeholder="Select permission grants"
      {...props}
    />
  );
}
